import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

// Этот компонент будет виден только на экранах меньше xl
export function InContentBanner() {
  return (
    // ✨ "ФИШКА": Добавляем hover-эффект для всего блока
    <Link 
      href="/contacts#advertising" // ✅ Ссылка ведет прямо на раздел рекламы
      className="xl:hidden block my-4 p-4 rounded-lg bg-gradient-to-r from-sky-900/50 to-slate-800/50 border border-sky-800/50 hover:border-sky-700/80 transition-all group"
    >
      <h4 className="font-bold text-sky-300">Расскажите о себе</h4>
      <p className="text-sm text-slate-400 mt-1 flex items-center">
        Разместите здесь свою рекламу. Узнайте больше
        {/* ✨ "ФИШКА": Анимированная стрелка для привлечения внимания */}
        <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" />
      </p>
    </Link>
  );
}

